/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 4,
    height: 12,
    viewBox: '0 0 4 12',
    data: '<g transform="translate(.066 .02)" _fill="#404040" fill-rule="evenodd"><path pid="0" d="M2.627 8.985l.335-1.35.742-2.99a.994.994 0 0 0-.725-1.204l-.097-.024a1 1 0 0 0-.194-.028l.001-.02-.043.02c-.306-.002-.752.295-.752.295C1.028 4.288-.158 5.089.017 5.47c.267.578 1.566-.943 1.254.31L.936 7.133l-.742 2.99c-.132.533.15 1.061.683 1.193l.096.024c.065.016.13.025.194.028l-.001.02.044-.02c.305.002.75-.295.75-.295.868-.604 2.075-1.4 1.9-1.781-.267-.578-1.544.948-1.233-.306z"/><circle pid="1" cx="2.49" cy="1.391" r="1.391"/></g>'
  }
})
